<script lang="ts" setup>
import TagItem from '@/components/common/atoms/tag.vue';

withDefaults(
  defineProps<{
    label?: string;
    selectedTags?: string[];
    isEditing?: boolean;
    showTooltip?: boolean;
    isPreventOverflow?: boolean;
  }>(),
  {
    selectedTags: () => [],
    isEditing: true,
    showTooltip: true,
    isPreventOverflow: true,
  },
);

const emit = defineEmits<{
  deleteTag: [item: string];
}>();

const deleteTag = (item: string) => {
  emit('deleteTag', item);
};
</script>

<template>
  <div class="selected-tag-list-row">
    <span class="selected-tag-list-label c-text-regular--s">
      {{ label }}
    </span>
    <TagItem
      class="selected-tag-item"
      v-for="item in selectedTags"
      :key="item"
      :name="item"
      :is-editing="isEditing"
      :show-tooltip="showTooltip"
      :is-prevent-overflow="isPreventOverflow"
      @delete-tag="deleteTag(item)"
    ></TagItem>
  </div>
</template>

<!-- FIXME: 影響範囲を調べて scoped をつける -->
<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
.selected-tag-list-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 8px;

  .selected-tag-list-label {
    color: $color-gray600;
  }

  .selected-tag-item {
    margin-left: 8px;
    height: 32px;
  }
}
</style>
